import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
  AbstractControlOptions,
} from "@angular/forms";
import { Router } from "@angular/router";
import { StrongPasswordRegex, ValidEmailRegex } from "../../../shared/regex";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
    standalone: false
})
export class RegisterComponent implements OnInit {
  /** Form object for registration input */
  protected registrationForm: FormGroup;

  /** Email regex */
  protected validEmailRegex = ValidEmailRegex;

  /**
   * Chacks for errors Flag
   * Use to check for error only after an action. So the error messages of the form
   * will not show until and action is taken.
   */
  protected checkErrors: boolean = false;

  constructor(private router: Router, private authService: AuthService) {
    // Set's up the registration form
    this.registrationForm = new FormGroup(
      {
        firstName: new FormControl<string>("", {
          validators: [Validators.required],
        }),
        lastName: new FormControl<string>("", {
          validators: [Validators.required],
        }),
        email: new FormControl<string>("", {
          validators: [
            Validators.required,
            Validators.pattern(ValidEmailRegex),
          ],
        }),
        password: new FormControl<string>("", {
          validators: [
            Validators.required,
            Validators.pattern(StrongPasswordRegex),
          ],
        }),
        password2: new FormControl<string>("", {
          validators: [Validators.required],
        }),
      },
      { validators: confirmPassword } as AbstractControlOptions
    );
  }

  ngOnInit() {}

  /** Takes the user back to the login page */
  goToLogin() {
    this.router.navigate(["/authentication/login"]);
  }

  /**
   * Gets a value from the form control
   * @param controlName The name of the control in the form to get.
   * @returns The expected control or null if the control does not exists.
   */
  getFormControl(controlName: string): AbstractControl | null {
    return this.registrationForm.get(controlName);
  }

  /**
   * Validate if passwords fields 'password' and 'password2' are the same. This is used to show or hide
   * to the user an error message dynamically if passwords fields are not matching.
   * @returns { boolean } True when fields match and false if not.
   */
  get isPasswordConfirmed(): boolean {
    return (
      this.registrationForm.get("password2")?.value ==
      this.registrationForm.get("password")?.value
    );
  }

  register() {
    // Activate the check for errors
    this.checkErrors = true;
    console.log("Getin ready for Registering...");

    // Signs in only when input form is valid
    if (this.registrationForm.valid) {
      // Register (SignUp) in using auth service
      console.log("Registering...");
      this.authService.registerNewUser(
        this.registrationForm.get("email")?.value,
        this.registrationForm.get("password")?.value,
        this.registrationForm.get("firstName")?.value,
        this.registrationForm.get("lastName")?.value
      );
    }
  }
}

/** Function used to validate passwords. Using a AbstractControl of one form with two fields for password, 'password' and 'password2'.
 * The function validates if the value in the two fields are equal or not. This functions works as a custom form validator, preventing
 * submision when this validations is not fulfilled.
 * @param {AbstractControl} control The form control used to retrieve form input values. It must have two inputs with the names
 * 'password' and 'password2'.
 * @returns { { [key: string]: any } | null } Returns an object with the attribuet passwordNotConfirmed equal to true if passwords doesn't match.
 * (These is needed to make this function work as validator for the FormGroup objetct).
 *
 * If the result is correct, the function will return null.
 */
function confirmPassword(
  control: AbstractControl
): { [key: string]: any } | null {
  const password = control.get("password")?.value;
  const password2 = control.get("password2")?.value;
  return password == password2 ? null : { passwordNotConfirmed: true };
}
